/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AdBlocker from 'cio/services/ad-blocker';

interface AdwordsSignature {
  Element: HTMLDivElement;
  Args: {
    onConnect: () => unknown;
  };
}

export default class Facebook extends Component<AdwordsSignature> {
  @service adBlocker!: AdBlocker;

  constructor(owner: unknown, args: AdwordsSignature['Args']) {
    super(owner, args);

    this.adBlocker.checkFacebook.perform();
  }
}
